module.exports =
  '_CONFIRMATION':
    'NEW':
      'TITLE': 'メールアドレスのご本人確認'
      'CURRENT_EMIL': '現在のご登録メールアドレス'
      'CONFIRMATION_MSG': '下記の操作を行い、ご自身のメールアドレスであることをお知らせ下さい'
      'INSTRUCTION_STEP1': '確認メールを送信（下記ボタンをタップ）'
      'INSTRUCTION_STEP2': '届いたメールの本文中にある URL をクリック'
      'INSTRUCTION_STEP3': 'メールアドレスのご本人確認が完了'
      'SEND': '確認メールを送信'
      'CHANGE_EMAIL_NOW': 'ご登録メールアドレスを変更されたい方はこちら'
      'ATTENTION_TITLE': '※ご注意ください※'
      'ATTENTION_MSG1': '確認メールは下記の件名で、こちらのシステムアカウントより送信されます'
      'ATTENTION_MSG2': '【件名】GOLF NETWORK PLUSメールアドレス確認'
      'ATTENTION_MSG3': '【送信元アカウント】no-reply@golfnetwork.jp'
      'EMAIL_SENT': '確認メールが送信されました。メールをご確認ください。'
    'EDIT':
      'TITLE': 'メール確認'
      'SUCCESS': 'メールアドレスの本人確認手続きが完了しました。'
      'INVALID': 'トークンが無効です。'
      'DASHBOARD': 'ダッシュボードに戻る'
    'NOTIFICATION':
      'TEXT': 'ご登録メールアドレスのご確認をお願いします'
    'ACCOUNT_PAGE':
      'TEXT': 'メールアドレスの本人確認手続きを行って下さい.'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/email-confirmation/i18n/ja.coffee